var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConnectionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2818_11149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.92578 1.42969H7.42578C7.691 1.42969 7.94535 1.53504 8.13289 1.72258C8.32042 1.91012 8.42578 2.16447 8.42578 2.42969V5.92969C8.42578 6.1949 8.32042 6.44926 8.13289 6.63679C7.94535 6.82433 7.691 6.92969 7.42578 6.92969H5.92578C5.39535 6.92969 4.88664 6.71897 4.51157 6.3439C4.13649 5.96883 3.92578 5.46012 3.92578 4.92969V3.42969C3.92578 2.89925 4.13649 2.39055 4.51157 2.01547C4.88664 1.6404 5.39535 1.42969 5.92578 1.42969V1.42969Z",
    stroke: "#007191",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.42578 2.92969H10.4258",
    stroke: "#007191",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.42578 5.42969H10.4258",
    stroke: "#007191",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.92578 4H1.92578C1.66056 4 1.40621 4.20018 1.21867 4.5565C1.03114 4.91282 0.925781 5.39609 0.925781 5.9V21.1C0.925781 21.6039 1.03114 22.0872 1.21867 22.4435C1.40621 22.7998 1.66056 23 1.92578 23H8.22874",
    stroke: "#007191",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9258 6.92969H16.4258C16.1606 6.92969 15.9062 6.82433 15.7187 6.63679C15.5311 6.44926 15.4258 6.1949 15.4258 5.92969V2.42969C15.4258 2.16447 15.5311 1.91012 15.7187 1.72258C15.9062 1.53504 16.1606 1.42969 16.4258 1.42969H17.9258C18.4562 1.42969 18.9649 1.6404 19.34 2.01547C19.7151 2.39055 19.9258 2.89925 19.9258 3.42969V4.92969C19.9258 5.46012 19.7151 5.96883 19.34 6.3439C18.9649 6.71897 18.4562 6.92969 17.9258 6.92969V6.92969Z",
    stroke: "#007191",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.926 4H21.926C22.1912 4 22.4455 4.20018 22.6331 4.5565C22.8206 4.91282 22.926 5.39609 22.926 5.9V21.1C22.926 21.6039 22.8206 22.0872 22.6331 22.4435C22.4455 22.7998 22.1912 23 21.926 23H14.771",
    stroke: "#007191",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2818_11149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectionIcon);
export default __webpack_public_path__ + "static/media/connection_icon.537a2e4531f3551ac01280954f209434.svg";
export { ForwardRef as ReactComponent };